import React from 'react';
import { Pagination } from 'rsuite';

interface TablePaginationProps {
  style?: React.CSSProperties;
  prev?: boolean;
  next?: boolean;
  first?: boolean;
  last?: boolean;
  ellipsis?: boolean;
  boundaryLinks?: boolean;
  maxButtons?: number;
  size?: 'xs'; 
  totalRecords?: number;
  limitOptions?: Array<number>;
  pageSize?: number;
  activePage?: number;
  onChangePage?: (page: number) => void;
  onChangeLimit?: (limit: number) => void;
}

const TablePagination: React.FC<TablePaginationProps> = ({ 
  style = { margin: 20 },
  prev = true,
  next = true,
  first = true,
  last = true,
  ellipsis = true,
  boundaryLinks = true,
  maxButtons = 5,
  size = "xs",
  totalRecords = 0,
  limitOptions = [10, 30, 50],
  pageSize = 10,
  activePage = 1,
  onChangePage,
  onChangeLimit
}) => {
  return (
    <Pagination
      style={style}
      prev={prev}
      next={next}
      first={first}
      last={last}
      ellipsis={ellipsis}
      boundaryLinks={boundaryLinks}
      maxButtons={maxButtons}
      size={size}
      layout={['total', '-', 'limit', '|', 'pager', 'skip']}
      total={totalRecords}
      limitOptions={limitOptions}
      limit={pageSize}
      activePage={activePage}
      onChangePage={onChangePage}
      onChangeLimit={onChangeLimit}
    />
  );
};

export default TablePagination;